export default {
  DEFAULT_FONT_SIZE: 25,
  MAX_FONT_SIZE: 70,
  MIN_FONT_SIZE: 12,
  aimColor: '#007EE5',
  cursorColor: '#9cd1ff'
}